import { addHexPrefix, stripHexPrefix } from '@ethereumjs/util';
import { useNavigate } from 'react-router-dom';
import { useParticleAuth } from '..';
import wallet from '../../api/wallet';
import tokenProvider from '../../provider';
import { EvmSignMethod, LoginQuery, SignQuery, SolanaSignMethod } from '../../provider/bundle';
import { PreferenceKey } from '../../repository';
import { isEMVMethod } from '../../utils/transaction-utils';
import { AuthError } from '../../utils/redirect-utils';

interface SignOptions {
    message: string;
    method: SolanaSignMethod | EvmSignMethod;
}
interface SignData {
    signature: string;
    error: AuthError;
}

const isPersonalSign = (signQuery: SignQuery) => {
    return signQuery.method === EvmSignMethod.personal_sign || signQuery.method === EvmSignMethod.personal_sign_uniq;
};

const encodeMessage = (message: string): string => {
    const hexString = Buffer.from(message, 'utf-8').toString('hex');
    return addHexPrefix(hexString);
};

const decodeMessage = (signQuery: SignQuery): string => {
    const msg = Buffer.from(stripHexPrefix(signQuery.message), 'hex').toString('utf-8');
    if (isPersonalSign(signQuery)) {
        if (/�/.test(msg)) {
            return signQuery.message;
        }
    }
    return msg;
};

const useSignData = () => {
    const { userInfo } = useParticleAuth();
    const navigate = useNavigate();
    const sign = async (options: SignOptions): Promise<string> => {
        const { message, method } = options;

        try {
            // if (sessionStorage.getItem('hasSetPaymentPassword') === 'true') {
            //     // 验证支付密码
            //     await new Promise((resolve, reject) => {
            //         setPaymentVerify({
            //             visible: true,
            //             onVerifyCompleted: resolve,
            //             onVerifyFailed: reject,
            //         });
            //     });
            // }
            console.log('sign message', message, method);

            if (isEMVMethod((tokenProvider.queryParam as SignQuery).method)) {
                return await wallet.evmSign(message, method);
            } else {
                return await wallet.solanaSign(message, method);
            }
        } catch (error: any) {
            throw new Error(error.message || error);
        }
    };

    const signWithoutConfirm = async (): Promise<SignData> => {
        let signResult: SignData = {} as SignData;
        try {
            if (!tokenProvider?.queryParam?.message) {
                throw new Error('message is required');
            }

            const signQuery = tokenProvider.queryParam as SignQuery;

            const signature = await sign({
                message: isEMVMethod((tokenProvider.queryParam as SignQuery).method)
                    ? decodeMessage(signQuery)
                    : signQuery.message,
                method: signQuery.method,
            });

            signResult.signature = signature;
            console.log('signWithoutConfirm success', signResult);
        } catch (error: any) {
            if (error.code && error.message) {
                signResult.error = error;
            } else {
                signResult.error = AuthError.authorizeError();
            }
            console.log('signWithoutConfirm error', signResult);
        }
        sessionStorage.setItem('signWithoutConfirmResult', JSON.stringify(signResult));
        return signResult;
    };

    const oldUserLoginSign = async () => {
        const authorization = (tokenProvider.queryParam as LoginQuery)?.authorization;
        let result = true;
        if (
            authorization?.message &&
            sessionStorage.getItem(PreferenceKey.PN_TEMP_REDIRECT_TYPE) === 'login' &&
            sessionStorage.getItem(PreferenceKey.PN_TEMP_IS_NEW_USER) !== 'true'
        ) {
            if (!userInfo?.security_account?.has_set_payment_password) {
                await signWithoutConfirm();
            } else if (isEMVMethod((tokenProvider.queryParam as SignQuery).method)) {
                navigate('/evm-chain/sign', { replace: true });
                result = false;
            } else {
                navigate('/solana/sign', { replace: true });
                result = false;
            }
        }
        return result; // 返回false 中断后面的逻辑
    };

    return {
        sign,
        signWithoutConfirm,
        oldUserLoginSign,
    };
};

export default useSignData;
